const base64: {
	encode: (str: string) => string,
	decode: (str: string) => string
} = {
	encode: (str: string) => window.btoa(encodeURIComponent(str)),
	decode:	(str: string) => decodeURIComponent(window.atob(str))
};

export {
	base64,
};
